import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useOrdemComprasListaFilters
 */

type State = {
  centroCusto: number[] | null;
  fornecedor: number[] | null;
  coletaPreco: number[] | null;
  ordemCompra: number[] | null;
  produtoServico: number[] | null;
  status: number[] | null;
  statusNF: number;
  nroNotaFiscal: string | null;
  dataOCStart: Date | null;
  dataOCEnd: Date | null;
};

export const initialOrdemComprasListaFilters: State = {
  centroCusto: null,
  fornecedor: null,
  coletaPreco: null,
  ordemCompra: null,
  produtoServico: null,
  status: [2, 4, 6],
  statusNF: 1,
  nroNotaFiscal: null,
  dataOCStart: null,
  dataOCEnd: null,
}

export const useOrdemComprasListaFilters = create<State>((set) => ({
  ...initialOrdemComprasListaFilters,
}));